(function() {
    angular.module('emarket.auth')
  .controller('SignInQuestionController', ['$log', 'Announcer', function($log, Announcer) {
      var announcer = Announcer.createEmitter();      
      announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR);
  }]);
}());
